module.exports = __webpack_public_path__ + "media/images/pikkachan_smile-663a435cb39f451de780c795202970e9.svg";